import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  geoRuntimeRowMetadata,
  humanGeoTypeLabel,
  NATAL_GEO_RUNTIME_VERSION,
} from '../../hooks/useNatalGeo';

export default function NatalBirthForm({

  visible,

  chart,

  form,

  handleChange,

  updateGeo,

  geoData,

  cityInputRef,

  findGeoAliasPreset,

  setForm,

  buildBirthPlaceString,

  setGeoOpen,

  setGeoResults,

  refreshDropdownRect,

  tryResolveTypedPlace,

  geoOpen,

  geoLoading,
  geoTimezoneError,
  geoTimezoneResolving,
  invalidateGeoTimezoneResolution,

  geoResults,

  dropdownRect,

  applyGeoPick,

  resolveCoords,

}) {
  const { t } = useTranslation('natal');

  if (!visible) return null;

  if (process.env.NODE_ENV !== 'production') {
    console.debug('[NATAL_GEO_RENDER_TRACE]', {
      runtimeVersion: NATAL_GEO_RUNTIME_VERSION,
      count: Array.isArray(geoResults) ? geoResults.length : 0,
      rows: Array.isArray(geoResults)
        ? geoResults.map((row, index) => geoRuntimeRowMetadata(row, index))
        : [],
    });
  }

  return (

      <div
      className="natal-birth-form"
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 12,
                position: 'relative',
                zIndex: 3,
              }}
      >
              <div>
                <label htmlFor="birthDate" style={{ fontSize: 13 }}>{t('birthDate')}</label>
                <input
                  id="birthDate"
                  type="date"
                  name="birthDate"
                  value={form.birthDate}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    marginTop: 4,
                    padding: '7px 10px',
                    borderRadius: 10,
                    border: '1px solid rgba(255,255,255,0.2)',
                    background: '#160030',
                    color: '#fff',
                    fontSize: 16,
                  }}
                />
              </div>

              <div>
                <label htmlFor="birthTime" style={{ fontSize: 13 }}>{t('birthTime')}</label>
                <input
                  id="birthTime"
                  type="time"
                  name="birthTime"
                  value={form.birthTime}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    marginTop: 4,
                    padding: '7px 10px',
                    borderRadius: 10,
                    border: '1px solid rgba(255,255,255,0.2)',
                    background: '#160030',
                    color: '#fff',
                    fontSize: 16,
                  }}
                />
              </div>

              <div>
                <label htmlFor="birthCityQuery" style={{ fontSize: 13 }}>{t('birthPlace')}</label>

                {/* Selector País */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 8, marginTop: 6 }}>
                  <select
                    id="birthCountry"
                    name="birthCountry"
                    value={form.birthCountry}
                    onChange={(e) => updateGeo({ birthCountry: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '8px 10px',
                      borderRadius: 10,
                      border: '1px solid rgba(255,255,255,0.2)',
                      background: '#160030',
                      color: '#fff',
                      fontSize: 16,
                    }}
                  >
                    {Object.keys(geoData).map((k) => (
                      <option key={k} value={k}>
                        {geoData[k].label || k}
                      </option>
                    ))}
                  </select>

                  {/* Provincia/Estado */}
                  <select
                    id="birthProvince"
                    name="birthProvince"
                    value={form.birthProvince}
                    onChange={(e) => updateGeo({ birthProvince: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '8px 10px',
                      borderRadius: 10,
                      border: '1px solid rgba(255,255,255,0.2)',
                      background: '#160030',
                      color: '#fff',
                      fontSize: 16,
                    }}
                  >
                    {Object.entries(geoData[form.birthCountry]?.provinces || {}).map(([k, v]) => (
                      <option key={k} value={k}>
                        {v.label || k}
                      </option>
                    ))}
                    <option value="OTRO">{t('otherPlace')}</option>
                  </select>

                  {/* Ciudad (búsqueda + geocoding, también para CABA) */}
    {form.birthProvince !== 'OTRO' ? (
      <div className="geo-dropdown-elevated" style={{ position: 'relative' }}>
        <input
          id="birthCityQuery"
          name="birthCityQuery"
          ref={cityInputRef}
          type="text"
          value={form.birthCityQuery}
          onChange={(e) => {
            const val = e.target.value;
            invalidateGeoTimezoneResolution();
            const matchedInlinePreset = findGeoAliasPreset({
              country: form.birthCountry,
              province: form.birthProvince,
              query: val,
            });

            setForm((prev) => {
              const next = { ...prev, birthCityQuery: val };

              if (matchedInlinePreset) {
                next.birthPlace = matchedInlinePreset.place;
                next.birthLat = matchedInlinePreset.lat;
                next.birthLon = matchedInlinePreset.lon;
                next.birthTzOffsetMin = matchedInlinePreset.tzOffsetMin;
                next.birthTimezone = matchedInlinePreset.timezone;
              } else {
                next.birthPlace = buildBirthPlaceString(next);
                next.birthLat = null;
                next.birthLon = null;
                next.birthTzOffsetMin = null;
                next.birthTimezone = null;
              }

              return next;
            });

            setGeoOpen(!matchedInlinePreset);
            if (matchedInlinePreset) {
              setGeoResults([]);
            }
            refreshDropdownRect();
          }}
          onFocus={() => {
            setGeoOpen(true);
            refreshDropdownRect();
          }}
          onBlur={(e) => {
            const rawValue = e.target.value;
            setTimeout(() => {
              tryResolveTypedPlace(rawValue);
            }, 0);
          }}
          placeholder={
            form.birthProvince === 'CABA'
              ? t('districtPlaceholder')
              : t('cityPlaceholder')
          }
          style={{
            width: '100%',
            padding: '8px 10px',
            borderRadius: 10,
            border: '1px solid rgba(255,255,255,0.2)',
            background: '#160030',
            color: '#fff',
            fontSize: 16,
          }}
        />

        {geoOpen && (geoLoading || geoResults.length > 0) && dropdownRect ? (
          <div
            style={{
              position: 'fixed',
              left: dropdownRect.left,
              width: dropdownRect.width,
              ...(dropdownRect.openUp
                ? { bottom: window.innerHeight - dropdownRect.top + 6 }
                : { top: dropdownRect.bottom + 6 }),
              zIndex: 9999,
              maxHeight: dropdownRect.maxHeight || 220,
              overflowY: 'auto',
              overflowX: 'hidden',
              overscrollBehavior: 'contain',
              WebkitOverflowScrolling: 'touch',
              borderRadius: 12,
              background: 'rgba(12,0,30,0.98)',
              border: '1px solid rgba(218,165,32,0.35)',
              boxShadow: '0 12px 28px rgba(0,0,0,0.6)',
            }}
          >
            {geoLoading ? (
              <div style={{ padding: '10px 12px', fontSize: 12, opacity: 0.85, color: '#fff' }}>
                {t('searching')}
              </div>
            ) : (
              geoResults.map((r, i) => (
                <button
                  key={`${r.complete_name || r.display || r.name || 'loc'}|${Number(r.lat).toFixed(6)}|${Number(r.lon).toFixed(6)}|${i}`}
                  type="button"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    applyGeoPick(r);
                  }}
                  onClick={(e) => e.preventDefault()}
                  style={{
                    width: '100%',
                    textAlign: 'left',
                    padding: '10px 12px',
                    background: 'transparent',
                    border: 'none',
                    color: '#fff',
                    cursor: 'pointer',
                    display: 'block',
                    borderTop: i === 0 ? 'none' : '1px solid rgba(255,255,255,0.08)',
                  }}
                >
                  <div style={{ fontWeight: 800, color: '#F7D26A', fontSize: 12 }}>
                    {(r.canonicalName || r.display || r.complete_name || r.name)
                      ?.split(',')[0]}
                  </div>
                  <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>
                    {(r.canonicalName || r.display || r.complete_name || r.name)
                      ?.split(',').slice(1).join(',').trim() || r.country || r.address?.country || ''}
                    {humanGeoTypeLabel(r) ? ` · ${humanGeoTypeLabel(r)}` : ''}
                    {typeof r.tzOffsetMin === 'number'
                      ? ` · UTC${r.tzOffsetMin >= 0 ? '+' : ''}${(r.tzOffsetMin / 60).toFixed(1)}`
                      : ''}
                  </div>
                </button>
              ))
            )}
          </div>
        ) : null}

        <div style={{ marginTop: 6, fontSize: 11, opacity: 0.75 }}>
          {t('locationTip')}
      </div>
      {geoTimezoneResolving ? (
        <div style={{ marginTop: 6, fontSize: 11, color: '#e9d8ff' }}>
          {t('timezoneResolving')}
        </div>
      ) : null}
      {!geoTimezoneResolving && geoTimezoneError ? (
        <div style={{ marginTop: 6, fontSize: 11, color: '#ffd5bd' }}>
          {t('timezoneResolutionError')}
        </div>
      ) : null}
                </div>
    ) : null}

    {form.birthProvince === 'OTRO' ? (
      <input
        id="birthPlaceManual"
        type="text"
        name="birthPlaceManual"
        value={form.birthPlaceManual}
        onChange={(e) => {
          const val = e.target.value;
          invalidateGeoTimezoneResolution();
          setForm((prev) => {
            const next = { ...prev, birthPlaceManual: val };
            next.birthPlace = buildBirthPlaceString(next);
            const { lat, lon } = resolveCoords(next);
            next.birthLat = lat;
            next.birthLon = lon;
            next.birthTzOffsetMin = null;
            next.birthTimezone = null;
            return next;
          });
        }}
        placeholder={t('placePlaceholder')}
        style={{
          width: '100%',
          padding: '8px 10px',
          borderRadius: 10,
          border: '1px solid rgba(255,255,255,0.2)',
          background: '#160030',
          color: '#fff',
          fontSize: 16,
        }}
      />
    ) : null}

    <div
      style={{
        marginTop: 2,
        fontSize: 11,
        opacity: 0.8,
        borderRadius: 10,
        padding: '8px 10px',
        background: 'rgba(0,0,0,0.22)',
        border: '1px solid rgba(255,255,255,0.12)',
      }}
    >
      <div style={{ fontWeight: 800, color: '#F7D26A', marginBottom: 2 }}>
        {t('savedAs')}
      </div>
      <div style={{ lineHeight: 1.25 }}>
        {form.birthPlace ? form.birthPlace : '—'}
      </div>
      <div style={{ marginTop: 4, opacity: 0.75 }}>
        {t('coordinates')}: {form.birthLat != null ? form.birthLat.toFixed(4) : '—'} ,{' '}
        {form.birthLon != null ? form.birthLon.toFixed(4) : '—'}
      </div>
      <div style={{ marginTop: 2, opacity: 0.7 }}>
        {t('timezone')}:{' '}
        {form.birthTimezone
          ? `${form.birthTimezone}${typeof form.birthTzOffsetMin === 'number' ? ` · UTC${form.birthTzOffsetMin >= 0 ? '+' : ''}${(form.birthTzOffsetMin / 60).toFixed(1)}` : ''}`
          : '—'}
      </div>
    </div>
                </div>
              </div>
            </div>

  );

}
